import { render, staticRenderFns } from "./FollowupList.vue?vue&type=template&id=03747c4c&"
import script from "./FollowupList.vue?vue&type=script&lang=js&"
export * from "./FollowupList.vue?vue&type=script&lang=js&"
import style0 from "./FollowupList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports